import AbstractPiniaModel from './AbstractPiniaModel'
import { useProfessionsStore } from '../pinia/stores/professions'
import { MainCategories } from 'Models'
import { Api } from 'Ajax'
import * as Sentry from "@sentry/browser";

export class Professions extends AbstractPiniaModel {
    //#region Instance Code
    constructor(profession) {
        super(profession)
    }

    id() {
        return Number(this.source.id)
    }
    title() {
        return this.source.titel
    }
    type() {
        return this.source.typ
    }
    code() {
        return this.source.code
    }
    description() {
        return this.source.beschreibung
    }
    image() {
        return this.source.picture
    }
    mainCategoryIds() {
        return this.source.main_category_ids
    }
    banner() {
        return this.source.banner
    }
    bannerLink() {
        return this.source.banner_link
    }
    keywords() {
        return this.source.keywords
    }

    extensionEndDeltaInMonths() {
        return this.source.verlaengerungs_end_delta_in_monaten
    }
    extensionStartDeltaInDays() {
        return this.source.verlaengerungs_start_delta_in_tagen
    }
    extensionCost() {

        Sentry.addBreadcrumb({
            category: "info",
            message: "extensionCost called: " + this.id(),
            level: "info",
            data: {
                professionId: this.id(),
                hasPrices: !!(this.source && this.source.prices),
            }
        });

        const p =
            this.source && this.source.prices
                ? this.source.prices.find(
                      (p) => p.type === 'renew' && p.period === 1
                  )
                : null
        return p ? p.amount : '14.90'
    }
    extensionTime() {
        return this.getByAliases(['verlaengerungs_laufzeit'], 1)
    }

    mainCategories() {
        return (this.mainCategoryIds() || []).map((mcID) =>
            MainCategories.createFromId(mcID)
        )
    }
    testIntro() {
        return this.source.testintro
    }
    omitSubcatDialog() {
        return this.testIntro() && this.testIntro().omit_subcat_dialog
    }

    isDemo() {
        return this.getByAliases(['nur_demo', false])
    }

    hasNoTemplates() {
        return this.source.has_no_templates
    }

    //#endregion Instance Code

    //#region Static Methods
    static piniaStore() {
        return useProfessionsStore()
    }

    static create(professionSource) {
        return new Professions(professionSource)
    }

    static hasAny() {
        return !this.piniaStore().allProfessionsEmpty
    }
    static isSubscribedTo(id) {
        return this.piniaStore().isSubscribedTo(id)
    }
    static isSubscribedToAny() {
        return this.piniaStore().subscribedProfessions.length > 0
    }
    static isAnySelected() {
        return this.getSelected().isEmpty()
    }

    static getSelected() {
        return Professions.create(this.piniaStore().selectedProfession)
    }
    static getByID(id) {
        return this.create(this.piniaStore().getProfessionById(id))
    }
    static getSubscribed() {
        return this.piniaStore().subscribedProfessions.map(
            (p) => new Professions(p)
        )
    }
    static getUnsubscribed() {
        return this.piniaStore().notSubscribedProfessions.map(
            (p) => new Professions(p)
        )
    }

    static init(professions) {
        this.dispatch(
            'initProfessions',
            professions.map((p) => p.getSource())
        )
    }
    static initSubscribed(professions) {
        this.dispatch(
            'initSubscribedProfessions',
            professions.map((p) => p.getSource())
        )
    }
    static selectByID(id) {
        this.dispatch('selectProfessionById', id)
    }
    static subscribeTo(profession) {
        this.dispatch('subscribeToProfession', profession.getSource())
    }
    //#endregion Static Methods
}
